import { ChevronLeft } from "lucide-react";
import { Server } from "@wajeez/wajeez.microservices";
import { Card, CardContent, CardTitle } from "@ui/card";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";
import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";
import { Skeleton } from "@ui/skeleton";
import { useState, useRef, useEffect } from "react";
import TranslatedText from "@components/items/display/TranslatedText";
import MarkdownView from "react-showdown";

export interface LiveTheAyahContentParameters {
  title: string | null | undefined;
  text: string | null | undefined;
  date: string | null | undefined;
}

interface LiveTheAyahContentProps {
  parameterValues: Partial<LiveTheAyahContentParameters>;
  content: Server.ContentEntityOutput | undefined | null;
  isLoading: boolean;
}

const LiveTheAyahContent = ({
  parameterValues,
  content,
  isLoading,
}: LiveTheAyahContentProps) => {
  const navigate = useAppNavigate();
  const { title, text } = parameterValues;

  const isLoadingVisible = useIsLoadingVisibile(isLoading && !content);

  return (
    <div
      className={`relative w-full ${
        (isLoadingVisible || isLoading) && "h-[325px]"
      } px-10 py-5`}
    >
      <div
        className={`absolute top-0 w-full px-10 py-5 ltr:left-0 rtl:right-0 ${
          (isLoadingVisible || isLoading) && "z-10 bg-white dark:bg-black"
        }`}
      >
        <LiveTheAyahContentLoading isLoading={isLoadingVisible} />
      </div>
      {content ? (
        <Card
          className="w-full cursor-pointer border-none bg-cover bg-center bg-no-repeat px-5 py-7"
          style={{ backgroundImage: "url('/assets/images/ayah-bg.png')" }}
          onClick={() => {
            content.id && navigate(`/details/${content.id}/`);
          }}
        >
          <CardTitle className="text-[32px] font-medium text-white">
            {title}
          </CardTitle>
          <CardContent className="flex items-center justify-start gap-x-8 p-0">
            <div className="pb-12 pt-3">
              <MarkdownView
                markdown={text || ""}
                options={{ tables: true, emoji: true }}
                className="line-clamp-3 text-[18px] leading-10 text-dark-ramadan-primary"
              />
            </div>
            <div className="absolute bottom-10 end-12 flex items-start justify-center text-[24px] font-medium text-white hover:opacity-80">
              <TranslatedText text="ramadan.ayah-button-text" />
              <ChevronLeft size={35} />
            </div>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
};

const LiveTheAyahContentLoading = ({ isLoading }: { isLoading: boolean }) => {
  return isLoading ? (
    <Skeleton
      className={`h-[285px] w-full rounded-[12px] bg-[#f4f4f5] dark:bg-[#27272a]`}
    ></Skeleton>
  ) : null;
};

export default LiveTheAyahContent;
